/* eslint-disable prettier/prettier */
import { Alert } from 'antd'
import { useSelector } from 'react-redux'
import { Router, Route, Switch, Redirect } from 'react-router-dom'

import { Parse } from 'parse'
import { QueryClient, QueryClientProvider } from 'react-query'

import './App.less'
import './App.css'
import './webfont.css'

import MainLayout from './layout/MainLayout'
import Login from './layout/Login'
import Signup from './layout/Signup'
import Reset from './layout/Reset'
import Upload from './layout/Upload'
import Guide from './layout/Guide'
import FAQ from './layout/FAQ'
import Home from './layout/Home'
import Mypage from './layout/Mypage'
import Event from './layout/Event'
import NotMatch from './layout/NotMatch'
import CheckPolicy from './layout/CheckPolicy'
import Report from './layout/Report'

import history from './rootHistory'

import { IntlProvider } from 'react-intl'
import en from './locale/en'
import ko from './locale/ko'

import { selectLocale } from './store/slice/locale'

// import * as reducers from './reducers' // Or wherever you keep your reducers

// Build the middleware for intercepting and dispatching navigation actions

// Parse initialize
Parse.initialize(process.env.REACT_APP_APP_ID, null)
Parse.serverURL = process.env.REACT_APP_SERVER_URL

//localStorage를 sessionStorage로 바꿔 저장하기
Parse.CoreManager.setStorageController({
  async: 0,

  getItem(path) {
    if (path.indexOf('installationId') > -1) {
      return localStorage.getItem(path)
    }
    return sessionStorage.getItem(path)
  },

  setItem(path, value) {
    try {
      if (path.indexOf('installationId') > -1) {
        localStorage.setItem(path, value)
      } else {
        sessionStorage.setItem(path, value)
      }
    } catch (e) {
      // Quota exceeded, possibly due to Safari Private Browsing mode
    }
  },

  removeItem(path) {
    sessionStorage.removeItem(path)
  },

  clear() {
    sessionStorage.clear()
  },
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
      staleTime: 1000,
    },
  },
})

// Now you can dispatch navigation actions from anywhere!
// store.dispatch(push('/foo'))

const withMainLayout = (ChildComponent) => (props) =>
  (
    <MainLayout>
      <ChildComponent {...props} />
    </MainLayout>
  )

export default function App() {
  const reduxLocale = useSelector(selectLocale)
  return (
    <QueryClientProvider client={queryClient}>
      <div className="app-wapper">
        {isChromeBrowser() ? null : history.location.pathname.startsWith(
            '/event/',
          ) ? null : (
          <Alert
            message={
              reduxLocale === 'en'
                ? en['Notice.optimizedForChrome']
                : ko['Notice.optimizedForChrome']
            }
            type="info"
            banner
          />
        )}
        <IntlProvider
          locale={reduxLocale}
          messages={reduxLocale === 'ko' ? ko : en}
        >
          <Router history={history}>
            <Switch>
              <Route path="/login" component={Login} />
              <Route path="/pageNotFound" component={NotMatch} />
              <Route path="/">
                <Switch>
                  <Route
                    exact
                    path="/"
                    component={() => <Home language={reduxLocale} />}
                  />
                  <PrivateRoute
                    path="/upload"
                    component={withMainLayout(Upload)}
                  />
                  <Route path="/guide" component={withMainLayout(Guide)} />
                  <Route path="/faq" component={withMainLayout(FAQ)} />
                  <PrivateRoute
                    path="/mypage"
                    component={withMainLayout(Mypage)}
                  />
                  <Route path="/signup" component={withMainLayout(Signup)} />
                  <Route path="/reset" component={withMainLayout(Reset)} />
                  <PrivateRoute
                    path="/policy"
                    component={withMainLayout(CheckPolicy)}
                  />
                  <PrivateRoute
                    path="/report"
                    component={withMainLayout(Report)}
                  />
                  <Route path="/event" component={Event} />
                  <Route component={NotMatch} />
                </Switch>
              </Route>
            </Switch>
          </Router>
        </IntlProvider>
      </div>
    </QueryClientProvider>
  )
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      Parse.User.current() ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/login',
            state: { from: props.location },
          }}
        />
      )
    }
  />
)
//현재 접속한 브라우저가 크롬인지 확인하는 함수
export const isChromeBrowser = () => {
  const agent = navigator.userAgent.toLowerCase()
  if (agent.indexOf('chrome') !== -1) {
    return true
  } else {
    return false
  }
}
